// Zichtbaarheidsdetectie via IntersectionObserver. Meldt wijzigingen als
// batch aan de callback: [{ element, inViewport }].
class IntersectionWatcher {
	constructor(options, onChanges) {
		this.options = options;
		this.onChanges = onChanges;
		this.observer = null;
	}

	watch(element) {
		if (!this.observer) {
			this.observer = new IntersectionObserver((entries) => {
				this.onChanges(entries.map(entry => ({
					element: entry.target,
					inViewport: entry.isIntersecting
				})));
			}, this.options);
		}

		this.observer.observe(element);
	}

	unwatch(element) {
		if (this.observer) {
			this.observer.unobserve(element);
		}
	}

	destroy() {
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}
	}
}

export default IntersectionWatcher;
